<template>
  <div class="row mt-4">
    <template>
      <div class="col-md-1">
        <input v-model="service.enable" type="checkbox">
      </div>

      <div class="col-md-5">
        <span>{{ service.friendlyName }}</span>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'Service',
  props: {
    credentials: {
      required: true,
      type: Array
    },
    service: {
      required: true,
      type: Object
    }
  },
}
</script>

<style scoped>

</style>